import React, { useState } from "react";
import {
  Container,
  Icon,
  TitleContainer,
  TextAfterIcon,
  IconsAndTextContainer,
} from "./eventView.styles";
import moment from "moment";
import { connect } from "react-redux";
import EditEvent from "../EditEvent/EditEvent";
import ReactTooltip from "react-tooltip";
import { isMobile } from "react-device-detect";
import { getStudentIncomes } from "../../../actions/incomesAction";
import useTeacheres from "../../useComponents/useTeachers";
import { getUsers } from "../../../actions/userActions";
import { getAgreementDetails } from "../../../actions/agreementsActions";
import {
  getStudentEvents,
  getStudentEventCount,
} from "../../../actions/schedulerActions";
import {
  getStudentTextBooks,
  fetchTextBook,
} from "../../../actions/textBooksActions";

const eventStatusIcons = {
  0: "icons8-question-mark",
  1: "icons8-checkmark",
  2: "icons8-shekel",
  3: "icons8-cancel",
  4: "icons8-cancel-with-usd",
};

const drivingPermitsOptions = [
  { value: 1, label: "הכשרה" },
  { value: 2, label: "רענון נהיגה" },
  { value: 3, label: "מטרונית" },
  { value: 4, label: "מפרקית" },
  { value: 5, label: "אוטובוס חשמלי" },
  { value: 6, label: "אוטובוס" },
  { value: 7, label: "אוטובוס בינערוני" },
  { value: 8, label: "מיניבוס" },
  { value: 9, label: "הסבה לקו" },
];

const EventView = (event) => {
  const [isEditLessonModalOpen, setIsEditLessonModalOpen] = useState(false);
  const [studentEventCount, setStudentEventCount] = useState(0);
  const [displayBalance, setDisplayBalance] = useState(false);
  const [balance, setBalance] = useState(0);

  const [isShowCount, setIsShowCount] = useState(false);
  const teachersOptions = useTeacheres(
    event.isUsersLoaded,
    event.getUsers,
    event.users
  );

  const getEventTypeIcon = (eventType) => {
    switch (eventType) {
      case 1:
        return <Icon className="icons8-steering-wheel" style={{ margin: 0 }} />;
      case 2:
        return <Icon className="icons8-graduation-cap" />;
      case 3:
        return <Icon className="icons8-road" />;
      case 4:
        return <Icon className="icons8-tie" />;
      default:
        return "";
    }
  };
  const formatPhoneForWhatsapp = (phoneNumber) => {
    phoneNumber = phoneNumber.trim();
    phoneNumber = phoneNumber.replaceAll('-', '');
    if (phoneNumber.includes('+972')) return phoneNumber;
    else if (phoneNumber.includes('972')) return '+' + phoneNumber;
    else {
      return '+972' + phoneNumber;
    }
  }

  const getStudentEventCount = async () => {
    if (!isShowCount) {
      const textBooksData = await event.fetchTextBook(event.event.textBookId);
      setStudentEventCount(
        textBooksData.remaininglessonsInMinutes / 40 +
          (await event.getStudentEventCount(
            event.event.eventType,
            event.event.studentId,
            event.event.textBookId,
            event.event.start
          ))
      );
      setIsShowCount(true);
    } else {
      setIsShowCount(false);
    }
  };

  const setStudentBalance = async () => {
    if (displayBalance) {
      setDisplayBalance(false);
    } else {
      const userEvents = await event.getStudentEvents(event.event.studentId);
      const fetchedStundetTextBooks = await event.getStudentTextBooks(
        event.event.studentId
      );
      const textBooksData = await event.fetchTextBook(
        fetchedStundetTextBooks[0].textBookId
      );

      const agreementsDetails = await event.getAgreementDetails(
        textBooksData.agreements[0].agreementId
      );

      let studentBalance = 0;
      studentBalance -= agreementsDetails.price;
      userEvents.map((x, i) => {
        const today = new Date();
        if (moment(x.start).isSameOrBefore(today)) {
          studentBalance -= x.price;
        }
        setBalance(studentBalance);
      });

      setDisplayBalance(true);
    }
  };

  const getNameStyle = (studentData) => {
    let styles = {};
    if (studentData.internalTestStatus) {
      styles.borderTop = "1px solid black";
    }
    if (
      studentData.conversion ||
      studentData.refresh ||
      studentData.renewal ||
      studentData.control
    ) {
      styles.borderLeft = "1px solid black";
      styles.borderRight = "1px solid black";
    }
    if (
      studentData.fundingBody !== 999 &&
      studentData.fundingBody !== null &&
      typeof studentData.fundingBody !== "undefined"
    ) {
      styles.borderBottom = "1px solid black";
    }

    return styles;
  };

  return !isMobile ? (
    <Container
      dir="auto"
      isStudentChosen={
        typeof event.chosenStudentId !== "undefined" &&
        event.chosenStudentId === event.event.studentId
      }
    >
      <ReactTooltip place="top" type="light" effect="float" html={true} />
      {isEditLessonModalOpen && (
        <EditEvent
          isNewAgreementModalOpen={isEditLessonModalOpen}
          setNewAgreementModalIsOpen={setIsEditLessonModalOpen}
          step={event.eventTime}
          selectedEvent={{
            ...event.event,
            name: event.event.name
              ? event.event.name
              : `${event.event.studentId} - ${event.event.firstName} ${event.event.lastName}`,
          }}
        />
      )}
      <TitleContainer
        // onClick={() => setIsEditLessonModalOpen(true)}
        dir="auto"
        className="eventView"
        isDay={event.isMargin}
      >
        {event.showEventStatus ? (
          <IconsAndTextContainer
            onClick={() => event.openEventStatusChangeModal(event.event)}
            style={{ margin: 0 }}
          >
            <Icon
              className={eventStatusIcons[event.event.eventStatus]}
              style={{ margin: 0 }}
              aria-hidden="true"
            />
          </IconsAndTextContainer>
        ) : null}
        {event.showTime ? (
          <IconsAndTextContainer onClick={() => setIsEditLessonModalOpen(true)}>
            <Icon className="icons8-clock" />
            <TextAfterIcon>
              {Math.round((event.event.end - event.event.start) / 1000 / 60)}
            </TextAfterIcon>
          </IconsAndTextContainer>
        ) : null}
        {event.showEventType ? (
          <IconsAndTextContainer onClick={() => getStudentEventCount()}>
            {getEventTypeIcon(event.event.eventType)}
            <TextAfterIcon>
              {isShowCount ? studentEventCount : event.event.title}
            </TextAfterIcon>
          </IconsAndTextContainer>
        ) : null}
        {event.showVehicle &&
        !isMobile &&
        typeof event.event.description === "string" ? (
          <IconsAndTextContainer
            onClick={() => event.openVehicleChange(event.event)}
          >
            <Icon
              className="icons8-car"
              data-tip={`<span dir="auto">${event.event.description}</span>`}
              data-for={event.event.id.toString()}
            />
            <TextAfterIcon>{event.event.description}</TextAfterIcon>
          </IconsAndTextContainer>
        ) : null}
        {/* <IconsAndTextContainer>
          <Icon className="fa fa-book" aria-hidden="true" />
          <TextAfterIcon>כרטסת</TextAfterIcon>
        </IconsAndTextContainer> */}
        {!isMobile &&
        typeof event.event.pickupLocationName === "string" &&
        event.event.pickupLocationName !== "ללא" ? (
          <IconsAndTextContainer
            onClick={() => event.openPickupModal(event.event.id)}
          >
            <Icon
              className="icons8-location"
              data-tip={`<span dir="auto">${event.event.pickupLocationName}</span>`}
              data-for={event.event.id.toString()}
            />
            <TextAfterIcon>{event.event.pickupLocationName}</TextAfterIcon>
          </IconsAndTextContainer>
        ) : null}
        {event.showStudent && typeof event.event.firstName === "string" ? (
          <IconsAndTextContainer
            // onClick={() => event.openStudentMenuModal(event.event)}
            onClick={() =>
              event.onStudentClick({
                event: event.event,
                value: event.event.studentId,
                label: `${event.event.firstName} ${event.event.lastName}`,
              })
            }
          >
            {/*<Icon
              className="icons8-user-group-man-man"
              data-tip={`<span dir="auto">${event.event.firstName} ${event.event.lastName}</span><br/><span dir="auto">${event.event.address}, ${event.event.city}</span><br/><span dir="auto">${event.event.phone}</span>`}
              data-for={event.event.id.toString()}
            />*/}
            <Icon
              className="icons8-whatsapp"
              onClick={() => window.open('https://wa.me/'+formatPhoneForWhatsapp(event.event.phone)+'?text='+`
 שלום לך, `+event.event.firstName + ' ' + event.event.lastName+`,
 ברצוני להזכירך כי בתאריך `+event.event.start.getDate() + '/' + (event.event.start.getMonth() + 1).toString() + '/' + event.event.start.getFullYear()+`, ב`+new Date(event.event.start).toLocaleString('he-il', {weekday:'long'})+`,
 בשעה `+event.event.start.getHours() +':'+event.event.start.getMinutes()+`
 קבענו שיעור.
 נתראה`+''+`
              `, '_blank')}
              data-tip={`<span dir="auto">${event.event.firstName} ${event.event.lastName}</span><br/><span dir="auto">${event.event.address}, ${event.event.city}</span><br/><span dir="auto">${event.event.phone}</span>`}
              data-for={event.event.id.toString()}
            />
            <TextAfterIcon
              isDay={event.isDay}
              style={{
                ...getNameStyle(event.event),
              }}
            >
              {event.event.firstName}&nbsp;
              {event.event.nickname && `(${event.event.nickname}) `}
              {event.event.lastName}
            </TextAfterIcon>
          </IconsAndTextContainer>
        ) : null}
        {event.showDrivingPermit &&
        !isMobile &&
        typeof event.event.drivingPermitId === "string" &&
        event.event.drivingPermitId !== "6" ? (
          <IconsAndTextContainer>
            <Icon className="fa fa-id-card" />
            <TextAfterIcon>
              {
                drivingPermitsOptions.find(
                  (x) => x.value.toString() === event.event.drivingPermitId
                )?.label
              }
            </TextAfterIcon>
          </IconsAndTextContainer>
        ) : null}
        {event.showBalance ? (
          <IconsAndTextContainer onClick={() => setStudentBalance()}>
            <Icon className="icons8-scales" />
            {displayBalance && <TextAfterIcon>{balance}</TextAfterIcon>}
          </IconsAndTextContainer>
        ) : null}
        {event.showNotes && typeof event.event.notes === "string" ? (
          <IconsAndTextContainer
            data-tip={event.event.notes}
            onClick={() => event.openNotesChangeModal(event.event)}
            data-for={event.event.id.toString()}
          >
            <Icon className="icons8-comments" />
            {!isMobile && <TextAfterIcon>{event.event.notes}</TextAfterIcon>}
          </IconsAndTextContainer>
        ) : null}
        {event.showBranch && event.event.eventType !== 4 ? (
          <IconsAndTextContainer>
            <Icon className="fa fa-building" />
            <TextAfterIcon>{event.event.branchName}</TextAfterIcon>
          </IconsAndTextContainer>
        ) : null}
        {event.showTeacher &&
        teachersOptions.length !== 0 &&
        event.event.teacherId !== null ? (
          <IconsAndTextContainer
            onClick={() => event.openTeacherChange(event.event)}
          >
            <Icon className="icons8-classroom" />
            <TextAfterIcon>
              {
                teachersOptions.find(
                  (x) => x.value.toString() === event.event.teacherId.toString()
                )?.label
              }
            </TextAfterIcon>
          </IconsAndTextContainer>
        ) : null}
      </TitleContainer>
    </Container>
  ) : (
    <Container dir="auto">
      <ReactTooltip place="top" type="light" effect="float" html={true} />
      {isEditLessonModalOpen && (
        <EditEvent
          isNewAgreementModalOpen={isEditLessonModalOpen}
          setNewAgreementModalIsOpen={setIsEditLessonModalOpen}
          step={event.eventTime}
          selectedEvent={{
            ...event.event,
            name: event.event.name
              ? event.event.name
              : `${event.event.studentId} - ${event.event.firstName} ${event.event.lastName}`,
          }}
        />
      )}
      <TitleContainer dir="auto" className="eventView" isDay={event.isMargin}>
        {event.showEventStatus ? (
          <IconsAndTextContainer
            onClick={() => event.openEventStatusChangeModal(event.event)}
            style={{ margin: 0 }}
          >
            <Icon
              className={eventStatusIcons[event.event.eventStatus]}
              style={{ margin: 0 }}
              aria-hidden="true"
            />
          </IconsAndTextContainer>
        ) : null}
        {event.showTime ? (
          <IconsAndTextContainer onClick={() => setIsEditLessonModalOpen(true)}>
            <Icon className="icons8-clock" />
            <TextAfterIcon>
              {Math.round((event.event.end - event.event.start) / 1000 / 60)}
            </TextAfterIcon>
          </IconsAndTextContainer>
        ) : null}
        {event.showEventType ? (
          <IconsAndTextContainer onClick={() => getStudentEventCount()}>
            {getEventTypeIcon(event.event.eventType)}
            <TextAfterIcon>
              {isShowCount ? studentEventCount : event.event.title}
            </TextAfterIcon>
          </IconsAndTextContainer>
        ) : null}
        {event.showBalance ? (
          <IconsAndTextContainer onClick={() => setStudentBalance()}>
            <Icon className="icons8-scales" />
            {displayBalance && <TextAfterIcon>{balance}</TextAfterIcon>}
          </IconsAndTextContainer>
        ) : null}
        {event.showNotes && typeof event.event.notes === "string" ? (
          <IconsAndTextContainer
            data-tip={event.event.notes}
            onClick={() => event.openNotesChangeModal(event.event)}
            data-for={event.event.id.toString()}
          >
            <Icon className="icons8-comments" />
            {!isMobile && <TextAfterIcon>{event.event.notes}</TextAfterIcon>}
          </IconsAndTextContainer>
        ) : null}
        {event.showVehicle && typeof event.event.description === "string" ? (
          <IconsAndTextContainer>
            <Icon
              className="icons8-car"
              data-tip={`<span dir="auto">${event.event.description}</span>`}
              data-for={event.event.id.toString()}
            />
            <TextAfterIcon>{event.event.description}</TextAfterIcon>
          </IconsAndTextContainer>
        ) : null}
      </TitleContainer>
      <div>
        {event.showStudent && typeof event.event.firstName === "string" ? (
          <IconsAndTextContainer
            // onClick={() => event.openStudentMenuModal(event.event)}
            onClick={() =>
              event.onStudentClick({
                event: event.event,
                value: event.event.studentId,
                label: `${event.event.firstName} ${event.event.lastName}`,
              })
            }
          >
            {/*<Icon
              className="icons8-user-group-man-man"
              data-tip={`<span dir="auto">${event.event.firstName} ${event.event.lastName}</span><br/><span dir="auto">${event.event.address}, ${event.event.city}</span><br/><span dir="auto">${event.event.phone}</span>`}
              data-for={event.event.id.toString()}
            />*/}
            <Icon
              className="icons8-whatsapp"
              onClick={() => window.open('https://wa.me/'+formatPhoneForWhatsapp(event.event.phone)+'?text='+`
 שלום לך, `+event.event.firstName + ' ' + event.event.lastName+`,
 ברצוני להזכירך כי בתאריך `+event.event.start.getDate() + '/' + (event.event.start.getMonth() + 1).toString() + '/' + event.event.start.getFullYear()+`, ב`+new Date(event.event.start).toLocaleString('he-il', {weekday:'long'})+`,
 בשעה `+event.event.start.getHours() +':'+event.event.start.getMinutes()+`
 קבענו שיעור.
 נתראה`+''+`
              `, '_blank')}
              data-tip={`<span dir="auto">${event.event.firstName} ${event.event.lastName}</span><br/><span dir="auto">${event.event.address}, ${event.event.city}</span><br/><span dir="auto">${event.event.phone}</span>`}
              data-for={event.event.id.toString()}
            />
            <TextAfterIcon
              isDay={event.isDay}
              style={{
                ...getNameStyle(event.event),
              }}
            >
              {event.event.firstName}&nbsp;
              {event.event.nickname ? `(${event.event.nickname}) ` : null}
              {event.event.lastName}
            </TextAfterIcon>
          </IconsAndTextContainer>
        ) : null}
        {event.showBranch && event.event.eventType !== 4 ? (
          <IconsAndTextContainer>
            <Icon className="fa fa-building" />
            <TextAfterIcon>{event.event.branchName}</TextAfterIcon>
          </IconsAndTextContainer>
        ) : null}
        {event.showTeacher &&
        teachersOptions.length !== 0 &&
        event.event.teacherId !== null ? (
          <IconsAndTextContainer>
            <Icon className="icons8-classroom" />
            <TextAfterIcon>
              {
                teachersOptions.find(
                  (x) => x.value.toString() === event.event.teacherId.toString()
                )?.label
              }
            </TextAfterIcon>
          </IconsAndTextContainer>
        ) : null}
      </div>
    </Container>
  );
};

function mapStateToProps(state, ownProps) {
  return {
    showEventType: state.session.user.showEventType,
    showEventStatus: state.session.user.showEventStatus,
    showStudent: state.session.user.showStudent,
    showVehicle: state.session.user.showVehicle,
    showTime: state.session.user.showTime,
    eventTime: state.session.user.eventTime,
    showBalance: state.session.user.showBalance,
    showBranch: state.session.user.showBranch,
    showNotes: state.session.user.showNotes,
    showTeacher: state.session.user.showTeacher,
    isUsersLoaded: state.UsersReducer.isLoaded,
    users: state.UsersReducer.users,
  };
}

export default connect(mapStateToProps, {
  getUsers,
  getAgreementDetails,
  getStudentEvents,
  getStudentEventCount,
  getStudentTextBooks,
  fetchTextBook,
  getStudentIncomes,
})(EventView);
